"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { WorkspaceElementType } from '@membranehq/sdk';
import { useElement } from '../element/useElement.mjs';

function useCustomer(selector) {
  const { item: customer, ...rest } = useElement(
    WorkspaceElementType.Customer,
    selector,
    (integrationApp) => selector ? integrationApp.customer(selector) : void 0
  );
  return { customer, ...rest };
}

export { useCustomer };
